import { useState, useEffect, useRef } from 'react';
import { webSocketService, QueueStatusChangedEvent } from '@/services/websocket.service';

export interface QueueRealtimeUpdate {
  currentSize?: number;
  estimatedWait?: number;
  status?: string;
}

export function useCatalogWebSocket(queueIds: string[]): { queueUpdates: Record<string, QueueRealtimeUpdate> } {
  const [queueUpdates, setQueueUpdates] = useState<Record<string, QueueRealtimeUpdate>>({});
  const queueIdsRef = useRef<string[]>([]);

  useEffect(() => {
    if (queueIds.length === 0) return;

    webSocketService.connect();

    queueIds.forEach(queueId => {
      webSocketService.subscribeToQueue(queueId);
    });
    queueIdsRef.current = queueIds;

    const handleStatusChanged = (data: QueueStatusChangedEvent) => {
      setQueueUpdates(prev => ({
        ...prev,
        [data.queueId]: {
          ...prev[data.queueId],
          status: data.status,
        },
      }));
    };

    webSocketService.on('queue:status:changed', handleStatusChanged);

    return () => {
      webSocketService.off('queue:status:changed', handleStatusChanged);
      queueIdsRef.current.forEach(queueId => {
        webSocketService.unsubscribeFromQueue(queueId);
      });
    };
  }, [queueIds.join(',')]); // eslint-disable-line react-hooks/exhaustive-deps

  return { queueUpdates };
}
